'use client';
import React from 'react';
import 'photoswipe/dist/photoswipe.css';
import Image from 'next/image';
import { Gallery, Item } from 'react-photoswipe-gallery';
import style from './style.module.scss'

interface MediaPosterProps {
  poster: string;
}
export const MediaPoster = ({ poster }: MediaPosterProps) => {
  return (
    <div className={style.wrapper }>
    <Gallery>
      <Item original={poster} thumbnail={poster} width="1024" height="768">
        {({ ref, open }) => (
          <Image
          style={{cursor: 'pointer'}}
            className={style.poster}
            objectFit="cover"
            ref={ref}
            onClick={open}
            src={poster}
            width={436}
            height={232}
            alt="poster"
          />
        )}
      </Item>
    </Gallery>
    </div>
  );
};
